import React from "react";
import styled from "styled-components";
import { Translation, t } from "../../../core/translate";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import {
  selectors as userSelectors,
  actions as userActions,
} from "../../../../redux/user";
import { actions as routerActions } from "../../../../redux/router";
import Spinner from "../../../components/spinner";
import { UnsafeHtml } from "../../../components/mixins";
import ContainerLayout from "../container-layout";
import { Button, Form } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";
import Terms from "../registration/terms";
import FormAlert from "../form-alert";

const TermsArea = styled.div`
  position: relative;
  background: #ffffff;
  width: 100%;
  max-width: 100%;
  height: 264px;
  border: 2px solid ${cloud.getShade(4)};
  overflow: auto;
  padding: 8px;
  margin-bottom: 15px;
`;

class TermsContainer extends React.Component {
  state = {};

  componentDidMount() {
    if (!this.props.hasAccepted) {
      this.loadZendesk();
    }
  }

  loadZendesk = () => {
    fetch(t("locations.zendesk-tou-api"))
      .then((json) => json.json())
      .then((data) => {
        this.setState({
          tos: { body: data.article.body, title: data.article.title },
        });
      })
      .catch((error) => this.setState({ errorLoadingZendesk: true }));
    fetch(t("locations.zendesk-privacy-api"))
      .then((json) => json.json())
      .then((data) => {
        this.setState({
          privacy: { body: data.article.body, title: data.article.title },
        });
      })
      .catch((error) => this.setState({ errorLoadingZendesk: true }));
    fetch(t("locations.zendesk-cookies-api"))
      .then((json) => json.json())
      .then((data) => {
        this.setState({
          cookies: { body: data.article.body, title: data.article.title },
        });
      })
      .catch((error) => this.setState({ errorLoadingZendesk: true }));
  };

  error = (error) => {
    this.setState({
      error: t(
        "messages.500-error",
        "Something went wrong. Please try again later."
      ),
    });
  };

  submit = (e) => {
    e.preventDefault();
    const form = e.target;
    const { jigsawBrand, setInfo } = this.props;
    setInfo({
      last_brand_accessed: jigsawBrand,
      eula_accepted: form.elements["user[eula_accepted]"].checked,
    }).then(({ success }) => {
      if (success) {
        // The router handles redirecting when terms are accepted
      } else {
        this.error();
      }
    });
  };

  renderTitle() {
    return (
      <Translation id="sso.terms-and-privacy">Terms and Privacy</Translation>
    );
  }

  renderTerms() {
    const { tos, privacy, cookies, errorLoadingZendesk, error } = this.state;
    return (
      <Form onSubmit={this.submit} id="terms-form" method="post">
        {!errorLoadingZendesk &&
          !this.props.termsURL &&
          !this.props.privacyURL &&
          !this.props.cookieURL && (
            <TermsArea>
              {!tos || !privacy || !cookies ? (
                <Spinner />
              ) : (
                <div>
                  {this.renderDoc(tos)}
                  {this.renderDoc(privacy)}
                  {this.renderDoc(cookies)}
                </div>
              )}
            </TermsArea>
          )}
        {error && (
          <FormAlert level="error" key={`error-${error}`}>
            {error}
          </FormAlert>
        )}
        <Terms />
        <Button id="submit-btn" fullWidth size="large">
          <Translation id="base.accept">Accept</Translation>
        </Button>
      </Form>
    );
  }

  renderDoc(doc) {
    if (doc) {
      return (
        <div>
          <h2>
            <UnsafeHtml>{doc.title}</UnsafeHtml>
          </h2>
          <UnsafeHtml>{doc.body}</UnsafeHtml>
          <hr />
        </div>
      );
    }
    return null;
  }

  render() {
    const { isUserFetching } = this.props;
    return (
      <ContainerLayout
        graphic="register"
        pageTitle={t("main-menu.terms", "Terms of Use")}
        title={this.renderTitle()}
      >
        {this.renderTerms()}
        {isUserFetching && <Spinner />}
      </ContainerLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  hasAccepted: userSelectors.hasAcceptedTOU(state),
  isUserFetching: userSelectors.isUserFetching(state),
  jigsawBrand: brandSelectors.getBrandValue(
    state,
    "jigsawBrand",
    "vitalsource"
  ),
  termsURL: brandSelectors.getBrandValue(state, "Terms.url", false),
  cookieURL: brandSelectors.getBrandValue(state, "Cookies.url", false),
  privacyURL: brandSelectors.getBrandValue(state, "Privacy.url", false),
});

const mapDispatchToProps = (dispatch) => ({
  setInfo: (userObject) => dispatch(userActions.setInfo(userObject)),
  go: (path) => dispatch(routerActions.go(path)),
});

const ConnectedTerms = connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsContainer);

export default ConnectedTerms;
